import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  FETCH_TOTAL_ANALYTICS,
  FETCH_TOTAL_ANALYTICS_ERROR,
  CLEAR_TOTAL_ANALYTICS,
  FETCH_DAY_BY_DAY_ANALYTICS,
  FETCH_DAY_BY_DAY_ANALYTICS_ERROR,
  CLEAR_DAY_BY_DAY_ANALYTICS,
  FETCH_TOP_LINKS,
  FETCH_TOP_LINKS_ERROR,
  CLEAR_TOP_LINKS,
  FETCH_TOP_LINK_DETAILS,
  FETCH_TOP_LINK_DETAILS_ERROR,
  CLEAR_TOP_LINK_DETAILS,
  FETCH_DEVICE_CATEGORIES,
  FETCH_DEVICE_CATEGORIES_ERROR,
  CLEAR_DEVICE_CATEGORIES,
  FETCH_MOBILE_DEVICES,
  FETCH_MOBILE_DEVICES_ERROR,
  CLEAR_MOBILE_DEVICES,
  FETCH_AUDIENCE_BY_COUNTRY,
  FETCH_AUDIENCE_BY_COUNTRY_ERROR,
  CLEAR_AUDIENCE_BY_COUNTRY,
  FETCH_AUDIENCE_BY_GLOBAL_MARKET,
  FETCH_AUDIENCE_BY_GLOBAL_MARKET_ERROR,
  CLEAR_AUDIENCE_BY_GLOBAL_MARKET,
  FETCH_AUDIENCE_BY_CITY,
  FETCH_AUDIENCE_BY_CITY_ERROR,
  CLEAR_AUDIENCE_BY_CITY,
  FETCH_REFERRERS,
  FETCH_REFERRERS_ERROR,
  CLEAR_REFERRERS,
  FETCH_TOP_LINKS_CSV,
  FETCH_TOP_LINKS_CSV_ERROR,
  CLEAR_FETCH_TOP_LINKS_CSV,
  FETCH_REFERRERS_CSV,
  FETCH_REFERRERS_CSV_ERROR,
  CLEAR_FETCH_REFERRERS_CSV,
} from 'redux/analytics/types';

export const fetchTotalAnalytics = days => baseErrorsHandlerDecorator(
  FETCH_TOTAL_ANALYTICS,
  FETCH_TOTAL_ANALYTICS_ERROR,
  () => restapi.get(addLang(`analytics/total/?days=${days}`)),
  false,
);

export const clearTotalAnalytics = () => dispatch => {
  dispatch({
    type: CLEAR_TOTAL_ANALYTICS,
  });
};

export const fetchDayByDayAnalytics = days => baseErrorsHandlerDecorator(
  FETCH_DAY_BY_DAY_ANALYTICS,
  FETCH_DAY_BY_DAY_ANALYTICS_ERROR,
  () => restapi.get(addLang(`analytics/day-by-day/?days=${days}`)),
  false,
);

export const clearDayByDayAnalytics = () => dispatch => {
  dispatch({
    type: CLEAR_DAY_BY_DAY_ANALYTICS,
  });
};

// Link List Analytics
export const fetchTopLinks = (days, showDeleted = true) => baseErrorsHandlerDecorator(
  FETCH_TOP_LINKS,
  FETCH_TOP_LINKS_ERROR,
  () => restapi.get(addLang(`analytics/links/?days=${days}&show_deleted=${showDeleted}`)),
  false,
);

// Link Details
export const fetchTopLinkDetails = (linkId, linkType, days) => baseErrorsHandlerDecorator(
  FETCH_TOP_LINK_DETAILS,
  FETCH_TOP_LINK_DETAILS_ERROR,
  () => restapi.get(addLang(`analytics/links/${linkType}/${linkId}/?days=${days}`)),
  false,
);
export const clearTopLinkDetails = () => dispatch => {
  dispatch({
    type: CLEAR_TOP_LINK_DETAILS,
  });
};

export const clearTopLinks = () => dispatch => {
  dispatch({
    type: CLEAR_TOP_LINKS,
  });
};

// Device Categories
export const fetchDeviceCategories = days => baseErrorsHandlerDecorator(
  FETCH_DEVICE_CATEGORIES,
  FETCH_DEVICE_CATEGORIES_ERROR,
  () => restapi.get(addLang(`analytics/charts/device-categories/?days=${days}`)),
  false,
);

export const clearDeviceCategories = () => dispatch => {
  dispatch({
    type: CLEAR_DEVICE_CATEGORIES,
  });
};

// Mobile Devices
export const fetchMobileDevices = days => baseErrorsHandlerDecorator(
  FETCH_MOBILE_DEVICES,
  FETCH_MOBILE_DEVICES_ERROR,
  () => restapi.get(addLang(`analytics/charts/mobile-devices/?days=${days}`)),
  false,
);

export const clearMobileDevices = () => dispatch => {
  dispatch({
    type: CLEAR_MOBILE_DEVICES,
  });
};

// Active Audience by Country
export const fetchAudienceByCountry = days => baseErrorsHandlerDecorator(
  FETCH_AUDIENCE_BY_COUNTRY,
  FETCH_AUDIENCE_BY_COUNTRY_ERROR,
  () => restapi.get(addLang(`analytics/charts/countries/?days=${days}`)),
  false,
);

export const clearAudienceByCountry = () => dispatch => {
  dispatch({
    type: CLEAR_AUDIENCE_BY_COUNTRY,
  });
};

// Active Audience by Global Market
export const fetchAudienceByGlobalMarket = days => baseErrorsHandlerDecorator(
  FETCH_AUDIENCE_BY_GLOBAL_MARKET,
  FETCH_AUDIENCE_BY_GLOBAL_MARKET_ERROR,
  () => restapi.get(addLang(`analytics/charts/continents/?days=${days}`)),
  false,
);

export const clearAudienceByGlobalMarket = () => dispatch => {
  dispatch({
    type: CLEAR_AUDIENCE_BY_GLOBAL_MARKET,
  });
};

// Active Audience by City
export const fetchAudienceByCity = days => baseErrorsHandlerDecorator(
  FETCH_AUDIENCE_BY_CITY,
  FETCH_AUDIENCE_BY_CITY_ERROR,
  () => restapi.get(addLang(`analytics/charts/cities/?days=${days}`)),
  false,
);

export const clearAudienceByCity = () => dispatch => {
  dispatch({
    type: CLEAR_AUDIENCE_BY_CITY,
  });
};

// Views by Referrer
export const fetchReferrers = days => baseErrorsHandlerDecorator(
  FETCH_REFERRERS,
  FETCH_REFERRERS_ERROR,
  () => restapi.get(addLang(`analytics/charts/referrers/?days=${days}`)),
  false,
);
export const clearReferrers = () => dispatch => {
  dispatch({
    type: CLEAR_REFERRERS,
  });
};

export const fetchTopLinksCsv = days => baseErrorsHandlerDecorator(
  FETCH_TOP_LINKS_CSV,
  FETCH_TOP_LINKS_CSV_ERROR,
  () => restapi.get(addLang(`analytics/links/download/?days=${days}`)),
  false,
);

export const clearFetchTopLinksCsv = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_TOP_LINKS_CSV,
  });
};

export const fetchReferrersCsv = days => baseErrorsHandlerDecorator(
  FETCH_REFERRERS_CSV,
  FETCH_REFERRERS_CSV_ERROR,
  () => restapi.get(addLang(`analytics/charts/referrers/download/?days=${days}`)),
  false,
);

export const clearFetchReferrersCsv = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_REFERRERS_CSV,
  });
};
